/**
 * Pure file-validation helpers shared by the UI store. Kept side-effect free so
 * they can be unit-tested without a DOM.
 */

/** Reject obviously-too-large files before spinning up the worker. */
export const MAX_FILE_BYTES = 150 * 1024 * 1024; // 150 MB

export interface FileLike {
  name: string;
  size: number;
}

/** File extensions this plugin accepts. */
export const ACCEPTED_EXTENSIONS = ['.eps'];

/** Returns an error message, or `null` when the file is acceptable. */
export function validateAiFile(file: FileLike): string | null {
  const name = file.name.toLowerCase();
  if (!ACCEPTED_EXTENSIONS.some((ext) => name.endsWith(ext))) {
    return 'Please choose an EPS (.eps) file.';
  }
  if (file.size === 0) {
    return 'That file is empty.';
  }
  if (file.size > MAX_FILE_BYTES) {
    return `That file is too large (max ${MAX_FILE_BYTES / 1024 / 1024} MB).`;
  }
  return null;
}
